import useSWR from "swr";
import fetcher from "../utils/fetch";
import { RelativeUrl } from "../utils/environment";

type MSANCTAType = string;

const useMSANCTATypes = () => {
  const { data, error, isLoading } = useSWR<MSANCTAType[]>(`${RelativeUrl}/microsoft/call_to_action_types`, fetcher, {
    revalidateIfStale: false // never refetch as settings will rarely change
  });

  return {
    ctaTypes: data || [],
    isLoading,
    error: error ? "Failed to fetch Google CTA types" : null
  };
};

export default useMSANCTATypes;
